module.exports = __webpack_public_path__ + "static/media/dingtalk_icon.baa28b68.svg";